import { cloneDeep } from 'lodash'
const state = {
  phoneNumber: '',
  captchaObj: {},
  startCountDown: false,
  userInfo: {},
  provinceInfo: {},
  cityInfo: {},
  districtInfo: {},
  provinceData: [],
  cityData: [],
  districtData: [],
  schoolData: [],
  areaList: [] // 国家/省/市/区数据
}

const mutations = {
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  },
  SET_COUNTDOWN_STATUS(state, status) {
    state.startCountDown = status
  },
  SET_CAPTCHA(state, obj) {
    state.captchaObj = obj
  },
  SET_PROVINCE_INFO(state, provinceInfo) {
    state.provinceInfo = provinceInfo
  },
  SET_CITY_INFO(state, cityInfo) {
    state.cityInfo = cityInfo
  },
  SET_DISTRICT_INFO(state, districtInfo) {
    state.districtInfo = districtInfo
  },
  SET_PROVENCE_DATA(state, payload) {
    state.areaList = payload.data.map(item => {
      item.children = []
      return item
    })
  },
  SET_CITY_DATA(state, payload) {
    const id = Number(payload.id)
    const data = payload.data
    state.areaList.forEach(v1 => {
      if (v1.id === id && !v1.children.length) {
        v1.children = data.map(item => {
          item.children = []
          return item
        })
      } else {
        v1.children = v1.children || undefined
      }
    })
    state.areaList = cloneDeep(state.areaList)
  },
  SET_DISISTRICT_DATA(state, payload) {
    const id = Number(payload.id)
    const data = payload.data
    state.areaList.forEach(v1 => {
      v1.children.forEach(v2 => {
        if (v2.id === id) {
          v2.children = data
        }
      })
    })
    state.areaList = cloneDeep(state.areaList)
  }
}

const actions = {
  // 获取引导状态
  async getGuideType({ commit, state }) {
    const res = await API.get(`/edu/zone/lessons/person/package/remind/status`)
    return res
  },
  // 设置引导状态
  async setGuideType({ commit, state }, remindType) {
    await API.put(`/edu/zone/lessons/person/package/remind/status`, { remindType })
  },
  async getProvinceList({ commit, state }, id) {
    if (state.areaList.length) return
    const res = await API.get(`/edu/base/location/country/${id}/provinces`)
    commit('SET_PROVENCE_DATA', {
      data: res.data.provinces
    })
  },
  async getCityList({ commit, state }, id) {
    const exist = state.areaList.some(v1 => {
      return v1.id === id && v1.children.length
    })
    if (exist) return
    const res = await API.get(`/edu/base/location/province/${id}/cities`)
    commit('SET_CITY_DATA', {
      id: id,
      data: res.data.cities
    })
  },
  async getDistrict({ commit, state }, id) {
    const exist = state.areaList.some(v1 => {
      return v1.children.some(v2 => {
        return v2.id === id && v2.children.length
      })
    })
    if (exist) return
    const res = await API.get(`/edu/base/location/city/${id}/districts`)
    commit('SET_DISISTRICT_DATA', {
      id: id,
      data: res.data.districts
    })
  }
}

export default {
  state,
  actions,
  mutations
}
